import React, { Component } from 'react';
import P from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { compose } from 'recompose';
import config from 'config';

import { IS_USER_LOGGED_IN } from 'gql/queries';
import ERROR_CODES from 'data/errorCodes';

export const ensureLoggedOut = (ChildComponent) => {
  class UserLoggedOutWrapper extends Component {
    static displayName = `UserLoggedOutWrapper(${ChildComponent.displayName || ChildComponent.name})`;

    static propTypes = {
      client: P.shape({
        query: P.func.isRequired,
      }),
      params: P.shape({
        query: P.shape({
          referrer: P.string,
        }),
      }),
    };

    async componentDidMount() {
      const { client } = this.props;

      try {
        const { data } = await client.query({ query: IS_USER_LOGGED_IN });
        if (data.store.user && data.store.user.id) {
          window.location.href = `${config.WEB_URL}/management-portal`;
        }
      } catch (e) {
        console.log(e)
        if (e.code === ERROR_CODES.UNAUTHENTICATED) {
          return;
        }
        throw e;
      }
    }

    render() {
      return <ChildComponent {...this.props} />;
    }
  }
  return compose(withApollo, withRouter)(UserLoggedOutWrapper);
};
